var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5229 20 20 15.5228 20 9.99999C20 4.47716 15.5229 0 10 0C4.47714 0 0 4.47716 0 9.99999C0 15.5228 4.47714 20 10 20ZM13.1197 4.65842C13.2715 4.11903 12.7481 3.80007 12.27 4.14065L5.59656 8.89479C5.07811 9.26414 5.15966 9.99999 5.71906 9.99999H7.47636V9.98639H10.9013L8.11061 10.971L6.88036 15.3416C6.72851 15.881 7.25191 16.1999 7.73001 15.8593L14.4035 11.1052C14.9219 10.7359 14.8403 9.99999 14.281 9.99999H11.6161L13.1197 4.65842Z",
    fill: "#155EEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany06);
export default __webpack_public_path__ + "static/media/company-06.e9c8745662a4e956760f433448871cda.svg";
export { ForwardRef as ReactComponent };